import type { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

import type { OneInchToken } from '@api';

interface TokenOptionProps extends ComponentPropsWithoutRef<'div'> {
  token: OneInchToken;
  hideName?: boolean;
  selectedView?: boolean;
}

export const TokenOption = ({
  token,
  className,
  selectedView,
  hideName,
  ...props
}: TokenOptionProps) => {
  if (selectedView) {
    return (
      <div
        className={classNames('flex gap-2 max-sm:gap-1 flex-wrap items-end', className)}
        {...props}
      >
        <div className={classNames('flex gap-2 max-sm:gap-1 items-center whitespace-nowrap')}>
          <ImageProxy
            width={36}
            height={36}
            className="icon-lg"
            src={token.attributes.logoURI}
            alt={token.attributes.symbol}
          />
          {token.attributes.symbol}
        </div>

        {!hideName && (
          <p className="t-body2 max-sm:text-[14px] text-neutral-400 pb-1 text-left">
            {token.attributes.name}
          </p>
        )}
      </div>
    );
  }

  return (
    <div className={classNames('flex gap-2 max-sm:gap-1 items-center', className)} {...props}>
      <ImageProxy
        width={28}
        height={28}
        className="icon-lg"
        src={token.attributes.logoURI}
        alt={token.attributes.symbol}
      />

      <div className={classNames('flex flex-col gap-1 justify-start whitespace-nowrap t-body2')}>
        {token.attributes.symbol}

        {!hideName && (
          <p className="t-body2 max-sm:text-[14px] font-light text-neutral-400 text-left">
            {token.attributes.name}
          </p>
        )}
      </div>
    </div>
  );
};
